import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ExercisesComponent} from './exercises/exercises.component';
import { TopicComponent } from './topic/topic.component';
import {DefectEncodingComponent} from './defect-encoding/defect-encoding.component';
import {CountDifferencesComponent} from './count-differences/count-differences.component';
import {BuildMessageComponent} from './build-message/build-message.component';
import {RepairEncodingComponent} from './repair-encoding/repair-encoding.component';
import {ReadMessageComponent} from './read-message/read-message.component';
import {BuildMessageReadMessageTwoPlayerComponent} from './build-message-read-message-two-player/build-message-read-message-two-player.component';


const dataRepresentationRoutes: Routes = [
  { path: 'encoding', component: TopicComponent,
    children : [
      { path: '', component: ExercisesComponent, pathMatch: 'full'},
      { path: 'defect-encoding/:id', component: DefectEncodingComponent},
      { path: 'count-differences/:id', component: CountDifferencesComponent},
      { path: 'build-message/:id', component: BuildMessageComponent},
      { path: 'repair-encoding/:id', component: RepairEncodingComponent},
      { path: 'read-message/:id', component: ReadMessageComponent},
      { path: 'build-message-read-message-two-player/:id', component: BuildMessageReadMessageTwoPlayerComponent}
    ] },
];

@NgModule({
  imports: [
    RouterModule.forChild(dataRepresentationRoutes)
  ],
  declarations: [],
  exports: [
    RouterModule]
})
export class TopicRoutingModule { }
